import { apiClient } from './apiClient';

export interface AiCredentials {
  access_key_id: string;
  secret_access_key: string;
  region: string;
}

export interface AiSettingsResponse {
  configured: boolean;
  credentials: AiCredentials;
}

export async function getAiSettings(): Promise<AiSettingsResponse> {
  const res = await apiClient.get<{ data: AiSettingsResponse }>('/admin/ai-settings');
  return res.data.data;
}

export async function updateAiSettings(
  credentials: Partial<AiCredentials>,
): Promise<AiSettingsResponse> {
  const res = await apiClient.put<{ data: AiSettingsResponse }>('/admin/ai-settings', credentials);
  return res.data.data;
}
